import gql from 'graphql-tag'

const saveAirports = gql`
  mutation saveAirports($airportIds: [String]!) {
    saveAirports(airportIds: $airportIds)
  }
`

const saveTravelParty = gql`
  mutation saveTravelParty($travelParty: [TravelPartyInput]!) {
    saveTravelParty(travelParty: $travelParty)
  }
`

const saveAccount = gql`
  mutation saveAccount($account: AccountInput!) {
    saveAccount(account: $account) {
      success
      errorMessage
    }
  }
`

const deleteProvider = gql`
  mutation deleteProvider($provider: String!) {
    deleteProvider(provider: $provider)
  }
`

const saveContactDetails = gql`
  mutation saveContactDetails($contactDetails: ContactDetailsInput!) {
    saveContactDetails(contactDetails: $contactDetails)
  }
`

const changePassword = gql`
  mutation changePassword($password: String!, $oldPassword: String) {
    changePassword(password: $password, oldPassword: $oldPassword) {
      success
      errorCode
    }
  }
`

const connectCoopDKPartner = gql`
  mutation connectCoopDKPartner($memberId: String!, $zipCode: String!) {
    connectCoopDKPartner(memberId: $memberId, zipCode: $zipCode) {
      success
      errorCode
    }
  }
`

const connectCoopSEPartner = gql`
  mutation connectCoopSEPartner($socialSecurityNumber: String!) {
    connectCoopSEPartner(socialSecurityNumber: $socialSecurityNumber) {
      success
      errorCode
    }
  }
`

const connectScandicPartner = gql`
  mutation connectScandicPartner($memberId: String!, $firstName: String!, $lastName: String!) {
    connectScandicPartner(memberId: $memberId, firstName: $firstName, lastName: $lastName) {
      success
      errorCode
    }
  }
`

const removePartner = gql`
  mutation removePartner($partnerId: String!) {
    removePartner(partnerId: $partnerId)
  }
`

export { changePassword, connectCoopDKPartner, connectCoopSEPartner, connectScandicPartner, deleteProvider, removePartner, saveAccount, saveAirports, saveContactDetails, saveTravelParty }
